import { render, staticRenderFns } from "./FixSumTemplate.vue?vue&type=template&id=5c24a882&"
import script from "./FixSumTemplate.vue?vue&type=script&lang=js&"
export * from "./FixSumTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FixSumTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports